import { ReactElement } from "react";

interface BatteryProps {
    value: number;
}

const Battery = (props: BatteryProps): ReactElement =>
{
    return (
        <div>
            Battery content {props.value}
        </div>
    );
}

export default Battery;